import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface PasswordResetRequest {
  email: string;
}

export interface PasswordChangeRequest {
  token: string;
  newPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  private readonly api = `${environment.baseUrl}/users`;

  constructor(private http: HttpClient) {}

  requestReset(body: PasswordResetRequest): Observable<void> {
    return this.http.post<void>(`${this.api}/password-reset`, body);
  }

  changePassword(body: PasswordChangeRequest): Observable<void> {
    return this.http.put<void>(`${this.api}/password`, body);
  }
}
